import { ReactNode } from 'react'
import { SchoolLogo } from './SchoolLogo'
import './Header.css'

interface HeaderProps {
  title?: string
  leftButtons?: ReactNode
  rightContent?: ReactNode
  showLogo?: boolean
}

export function Header({ 
  title, 
  leftButtons, 
  rightContent,
  showLogo = true 
}: HeaderProps) {
  return (
    <div className="app-header">
      <div className="header-left">
        {leftButtons}
        {title && <h1>{title}</h1>}
      </div>
      <div className="header-right">
        {rightContent}
        {showLogo && (
          <div className="header-logo">
            <SchoolLogo height="40px" />
          </div>
        )}
      </div>
    </div>
  )
}

